import React from 'react';
import File from './File';
import { useTranslation } from 'react-i18next';
import BreadCrumbs from '../common/BreadCrumbs';
import Page from '../common/Page';

const FilePage = () => {

    const { t } = useTranslation();

    return (
        <Page>
            <BreadCrumbs stack={[
                {title: t("Domů"), path: "/"},
                {title: t("Soubory"), path: "/file"}
            ]} />
            <File />
        </Page>
    );
};

export default FilePage;